<template>
  <div
    class="row kft-product__summary__private-event-info mt-8 border-radius-sm m-0"
    itemscope
    itemtype="https://schema.org/FAQPage"
  >
    <div
      class="pointer d-flex mt-5 justify-content-between align-items-sm-center align-items-lg-start"
    >
      <i class="bi bi-people-fill font-size-6 pt-2 pe-4" />
      <Heading
        :level="6"
        :title="$t('product.show.privateEventInfo.title')"
        class="flex-column w-100 kft-heading--left kft-product__summary__heading"
        h-class="mt-2"
        itemprop="mainEntity"
        itemscope
        itemtype="https://schema.org/Question"
      />
      <div
        itemprop="acceptedAnswer"
        itemscope
        itemtype="https://schema.org/Answer"
        class="mt-4"
      >
        {{ description }}
      </div>
    </div>
  </div>
</template>

<script lang="ts">
export default {
  props: {
    description: {
      type: String,
      required: true,
    },
  },
}
</script>

<style lang="postcss" scoped>
.kft-product {
  &__summary {
    &__private-event-info {
      padding: 0;
      @include for-tablet-and-up {
        padding: 0 1rem 1.5rem 1rem;
        background: $footer-background-color;
      }

      &__info > div {
        width: 50%;
      }
    }
  }
}
</style>
